import { render, staticRenderFns } from "./Reservation_Edit.vue?vue&type=template&id=2260345a&"
import script from "./Reservation_Edit.vue?vue&type=script&lang=js&"
export * from "./Reservation_Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports